import { LearnerFileType } from "@api/graphql/types-and-hooks";
import { DocumentViewerImage } from "@components/DocumentReviewModal/components/DocumentViewerImage";
import { DocumentViewerPDF } from "@components/DocumentReviewModal/components/DocumentViewerPDF";
import { DocumentViewerXLSX } from "@components/DocumentReviewModal/components/DocumentViewerXLSX";

const XLSX_MIME_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
  "application/vnd.ms-excel", // xls (legacy binary format)
];

interface DocumentViewerProps {
  file: LearnerFileType;
  width: number;
}

export const DocumentViewer: React.FC<DocumentViewerProps> = ({ file, width }) => {
  if (XLSX_MIME_TYPES.includes(file.mimeType ?? "")) {
    return <DocumentViewerXLSX file={file} width={width} />;
  }

  if (!file.signedS3LearnerFile) {
    return (
      <div className="flex items-center justify-center h-full">
        <p>File is not available</p>
      </div>
    );
  }

  if (file.mimeType === "application/pdf") {
    return <DocumentViewerPDF file={file} width={width} />;
  }

  if (file.mimeType.startsWith("image/")) {
    return <DocumentViewerImage file={file} />;
  }

  return (
    <div className="flex items-center justify-center h-full">
      <p>Preview not available for this file type</p>
    </div>
  );
};
